import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@carvana/theme';
import { DocumentWizardPropTypes, DocumentWizardDefaultProps } from './document-wizard.props'
import * as sc from './document-wizard.styles';
import DocumentPreview from './components/document-preview';

const DocumentWizard = props => {
  const { isMobile } = useSelector(state => state.ui.screenSize);
  const { documents } = props;
  const [activeDocument] = useState(documents?.[0]);

  if (!activeDocument) return null;

  return (
    <ThemeProvider>
      <sc.Wrapper>
        <sc.FormsWrapper>
          {!(props.hideDocumentPreviewMobileWeb && isMobile) && 
            <DocumentPreview
              documentSelectOn={props.documentSelectOn}
              images={activeDocument.images}
              removeDocument={props.removeDocument}
            />
          }
          {!!documents?.length && activeDocument?.forms?.length &&
            <sc.DocWizardSection>
              {activeDocument?.forms?.[0]}
            </sc.DocWizardSection>
          }
        </sc.FormsWrapper>

      </sc.Wrapper>
    </ThemeProvider>
  );
};

DocumentWizard.propTypes = DocumentWizardPropTypes;
DocumentWizard.defaultProps = DocumentWizardDefaultProps;

export default DocumentWizard;
